import Vue from "vue";
import Router from "vue-router";

import Account from "./views/Account";

import Dashboard from "./views/Dashboard";
import DashboardMonitoring from "./views/DashboardMonitoring";

import Beds from "./views/Beds";

import Cares from "./views/Cares";

import CaresResident from "./views/CaresResident";

import Care from "./views/Care";

import VitalSign from "./views/VitalSign";

import Branch from "./views/Branch";
import Doctor from "./views/doctor";

import PrescriptionPrint from "./templates/Prescription/GroupMedicine/Print";
import PrescriptionPrints from "./templates/Prescription/GroupMedicine/Prints";

import SchedulePrint from "./templates/Prescription/Schedule/Print";

import Checks from "./views/Checks";
import Check from "./views/Check";
import MedicineCheckPrint from "./templates/Resident/DailyRoutine/Prescription/Print/Normal";
import MedicineCheckPrintLongTerm from "./templates/Resident/DailyRoutine/Prescription/Print/LongTerm";

import PrintOutAnnotation from "./templates/Care/NursingCaregiver/Print/Annotation";
import PrintOutVitalSign from "./templates/Care/NursingCaregiver/Print/VitalSign";

import Reports from "./templates/Reports/Reports";
import ReportsAnnotation from "./templates/Reports/Annotation";
import ReportsEvolution from "./templates/Reports/Evolution";
import ReportsMedicineCheckGeneral from "./templates/Reports/Check/General/View";
import ReportsMedicineCheckAnalytical from "./templates/Reports/Check/Analytical/View";
import ReportsMedicineStock from "./templates/Reports/MedicineStock";
import ReportsMedicineStockResident from "./templates/Reports/MedicineStockResident";
import ReportsMedicineStockTotal from "./templates/Reports/MedicineStockTotal";
import ReportsResidents from "./templates/Reports/Residents";
import ReportsTerminationContract from "./templates/Reports/TerminationContract";

import ReportAnnotation from "./templates/Care/NursingCaregiver/View/Report/Annotation";
import ReportVitalSigns from "./templates/Care/NursingCaregiver/View/Report/VitalSigns";
import ReportEvolution from "./templates/Reports/Evolution/Evolution";

import UserCare from "./templates/User/Care";

import BuyDetails from "./templates/Buy/BuyDetails";

import DocsFolder from "./views/DocsFolder";

import UsersGroup from "./views/UsersGroup";

import UsersProfile from "./views/UsersProfile";

import Users from "./views/Users";
import User from "./views/User";
import UserPrint from "./views/UserPrint";

import Residents from "./views/Residents";
import Resident from "./views/Resident";
import PrintResident from "./templates/Resident/Print";

import Customers from "./views/Customers";
import Customer from "./views/Customer";
import PrintCustomer from "./templates/Customer/Print";

import Duty from "./views/Duty";

import Medicines from "./views/Medicines";
import Medicine from "./templates/Medicine/ViewMedicine";

import Products from "./views/Products";
import Product from "./templates/Product/ViewProduct";

import KitsTypes from "./views/KitsTypes";

import ServicesChargeTypes from "./views/ServicesChargeTypes";

import Services from "./views/Services";

import Provider from "./views/Provider";
import Providers from "./views/Providers";

import ProductKit from "./views/ProductKit";

import Permissions from "./views/Permissions";

import Devices from "./views/Devices";
import NewDevice from "./views/NewDevice";

import Financial from "./views/Financial";

import Security from "./views/Security";
import StockConfig from "./views/StockConfig";
import AdvanceNotification from "./views/AdvanceNotification";
import ConfigHomeCare from "./views/ConfigHomeCare";
import ConfigBoleto from "./views/ConfigBoleto";
import NfeChangeNameItem from "./views/NfeChangeNameItem";

import Help from "./views/Help";
import VerifyPDF from "./views/verify-PDF";

import Lists from "./views/Lists";
import List from "./views/List";
import ListTable from "./views/ListTable";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "sign-in",
      alias: "/sign-in",
      component: () => import("./views/SignIn"),
    },
    {
      path: "/new-password",
      name: "new-password",
      component: () => import("./views/NewPassword"),
    },
    {
      path: "/new-password/:token",
      name: "new-password-token",
      component: () => import("./views/NewPassword"),
    },
    {
      path: "/account",
      name: "account",
      component: Account,
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
    },
    {
      path: "/dashboard-monitoring",
      name: "dashboard_monitoring",
      component: DashboardMonitoring,
    },
    {
      path: "/branch",
      name: "branch",
      component: Branch,
    },
    {
      path: "/doctor",
      name: "doctor",
      component: Doctor,
    },
    {
      path: "/cares",
      name: "cares",
      component: Cares,
    },
    {
      path: "/cares/resident/:resident_id",
      name: "caresResident",
      component: CaresResident,
    },
    {
      path: "/care/:id",
      name: "care",
      component: Care,
    },
    {
      path: "/vital_sign/:id",
      name: "vital_sign",
      component: VitalSign,
    },
    {
      path: "/print/annotation/:id",
      name: "print_care",
      component: PrintOutAnnotation,
    },
    {
      path: "/print/vital-sign/:id",
      name: "print_vital_sign",
      component: PrintOutVitalSign,
    },
    {
      path: "/user/care/:user_id/:resident_id",
      name: "user_care",
      component: UserCare,
    },
    {
      path: "/beds",
      name: "beds",
      component: Beds,
    },
    {
      path: "/types-of-hosting",
      name: "types-of-hosting",
      component: () => import('./views/TypesOfHosting'),
    },
    {
      path: "/usersgroup",
      name: "usersgroup",
      component: UsersGroup,
    },
    {
      path: "/usersprofile",
      name: "usersprofile",
      component: UsersProfile,
    },
    {
      path: "/users",
      name: "users",
      component: Users,
    },
    {
      path: "/user/:id",
      name: "user",
      component: User,
    },
    {
      path: "/user/print/:id",
      name: "user_print",
      component: UserPrint,
    },
    {
      path: "/residents",
      name: "residents",
      component: Residents,
    },
    {
      path: "/resident/:id",
      name: "resident",
      component: Resident,
    },
    {
      path: "/print/resident/:id",
      name: "print_resident",
      component: PrintResident,
    },
    {
      path: "/customers",
      name: "customers",
      component: Customers,
    },
    {
      path: "/duty",
      name: "duty",
      component: Duty,
    },
    {
      path: "/medicines",
      name: "medicines",
      component: Medicines,
    },
    {
      path: "/medicine/:id",
      name: "medicine",
      component: Medicine,
    },
    {
      path: "/products",
      name: "products",
      component: Products,
    },
    {
      path: "/product/:id",
      name: "product",
      component: Product,
    },
    {
      path: "/kitstypes",
      name: "kitstypes",
      component: KitsTypes,
    },
    {
      path: "/serviceschargetypes",
      name: "serviceschargetypes",
      component: ServicesChargeTypes,
    },
    {
      path: "/services",
      name: "services",
      component: Services,
    },
    {
      path: "/provider/:id",
      name: "provider",
      component: Provider,
    },
    {
      path: "/providers",
      name: "providers",
      component: Providers,
    },
    {
      path: "/customer/:id",
      name: "customer",
      component: Customer,
    },
    {
      path: "/print/customer/:id",
      name: "print_customer",
      component: PrintCustomer,
    },
    {
      path: "/product_kit/:id",
      name: "product_kit",
      component: ProductKit,
    },
    {
      path: "/permissions",
      name: "permissions",
      component: Permissions,
    },
    {
      path: "/devices",
      name: "devices",
      component: Devices,
    },
    {
      path: "/newdevice",
      name: "newdevice",
      component: NewDevice,
    },
    {
      path: "/import-residents",
      name: "import_residents",
      component: () => import("./views/ImportResidents"),
    },
    {
      path: "/import-users",
      name: "import_users",
      component: () => import("./views/ImportUsers"),
    },
    {
      path: "/import-medicines",
      name: "import-medicines",
      component: () => import("./views/ImportMedicines"),
    },
    {
      path: "/medicine-one-third",
      name: "medicine-one-third",
      component: () => import("./views/MedicineOneThird"),
    },
    {
      path: "/reports",
      name: "reports",
      component: Reports,
    },
    {
      path: "/reports/annotation",
      name: "reports_annotation",
      component: ReportsAnnotation,
    },
    {
      path: "/reports/evolution",
      name: "reports_evolution",
      component: ReportsEvolution,
    },
    {
      path: "/reports/check-general",
      name: "reports_check_general",
      component: ReportsMedicineCheckGeneral,
    },
    {
      path: "/reports/check-analytical",
      name: "reports_check_analytical",
      component: ReportsMedicineCheckAnalytical,
    },
    {
      path: "/reports/medicine-stock",
      name: "reports_medicine_stock",
      component: ReportsMedicineStock,
    },
    {
      path: "/reports/medicine-stock-resident",
      name: "reports_medicine_stock_resident",
      component: ReportsMedicineStockResident,
    },
    {
      path: "/reports/medicine-stock-total",
      name: "reports_medicine_stock_total",
      component: ReportsMedicineStockTotal,
    },
    {
      path: "/reports/residents",
      name: "reports_residents",
      component: ReportsResidents,
    },
    {
      path: "/reports/termination-contract",
      name: "reports_termination_contract",
      component: ReportsTerminationContract,
    },
    {
      path: "/report/annotation/001/:resident_id/:care_ids/:vital_sign_ids",
      name: "report_annotation",
      component: ReportAnnotation,
    },
    {
      path: "/report/vital-signs/001/:care_ids",
      name: "report_vital_signs",
      component: ReportVitalSigns,
    },
    {
      path: "/report/evolution/:type/:types/:resident_ids/:ids/:dtInit/:dtEnd",
      name: "report_evolution",
      component: ReportEvolution,
    },
    {
      path: "/prescription/print/:id",
      name: "group_prescription_medicine_print",
      component: PrescriptionPrint,
    },
    {
      path: "/prescription/prints/:ids",
      name: "group_prescription_medicine_prints",
      component: PrescriptionPrints,
    },
    {
      path: "/schedule/print/:id",
      name: "schedule_print",
      component: SchedulePrint,
    },
    {
      path: "/checks/:id?",
      name: "checks",
      component: Checks,
    },
    {
      path: "/check/:id",
      name: "check",
      component: Check,
    },
    {
      path:
        "/medicine/check/print/:resident_id/:date/:end_date/:order_by/:frequency",
      name: "medicine_check_print",
      component: MedicineCheckPrint,
    },
    {
      path:
        "/medicine/check/long-term/print/:resident_id/:date/:end_date/:order_by/:frequency",
      name: "medicine_check_print_long_term",
      component: MedicineCheckPrintLongTerm,
    },
    {
      path: "/new-stock",
      name: "new-stock",
      component: () => import("./views/NewStock"),
    },
    {
      path: "/semiology-forms",
      name: "semiology-forms",
      component: () => import("./views/SemiologyForms"),
    },
    {
      path: "/semiology-form/:id",
      name: "semiology-form",
      component: () => import("./views/SemiologyForm"),
    },
    {
      path: "/print/evolution/:id",
      name: "print_evolution",
      component: () => import("./templates/Evolution/Print/Evolution"),
    },
    {
      path: "/graphics",
      name: "graphics",
      component: () => import("./views/Graphics"),
    },
    {
      path: "/verificar-medicamentos-parecidos",
      name: "verify_medicines",
      component: () => import("./views/VerifyMedicines"),
    },
    {
      path: "/report-stock",
      name: "stock_report",
      component: () => import("./templates/Reports/Stock/View"),
    },
    {
      path: "/report-stock-borrowed",
      name: "stock_borrowed",
      component: () => import("./templates/Reports/Stock/Borrowed"),
    },
    {
      path: "/answer-semiologies",
      name: "answer-semiologies",
      component: () => import('./views/AnswerSemiologies'),
    },
    {
      path: "/answer-lists",
      name: "answer-lists",
      component: () => import('./views/AnswerLists'),
    },
    {
      path: "/resident-answered-semiologies",
      name: "resident-answered-semiologies",
      component: () => import('./views/ResidentAnsweredSemiologies'),
    },
    {
      path: "/answered-semiologies/:resident_id",
      name: "answered-semiologies",
      component: () => import('./views/AnsweredSemiologies'),
    },
    {
      path: "/print/cheers/:resident_id/:date/:next_or_previous",
      name: "print-cheers",
      component: () => import('./templates/Resident/Cheers/Print'),
    },
    {
      path: "/print/semiology/:resident_id/:semiology_form_id/:semiology_form_question_answer_id",
      name: "print-semiology",
      component: () => import('./templates/Resident/Semiology/AnsweredFormPrint'),
    },
    {
      path: "/security",
      name: "security",
      component: Security,
    },
    {
      path: "/stock-config",
      name: "stock-config",
      component: StockConfig,
    },
    {
      path: "/advance-notification",
      name: "advance-notification",
      component: AdvanceNotification,
    },
    {
      path: "/config-home-care",
      name: "config-home-care",
      component: ConfigHomeCare,
    },
    {
      path: "/config-boleto",
      name: "config-boleto",
      component: ConfigBoleto,
    },
    {
      path: "/nfe-change-name-item",
      name: "nfe-change-name-item",
      component: NfeChangeNameItem,
    },
    {
      path: "/receipt-print/:id",
      name: "receipt-print",
      component: () => import('./templates/Financial/Releases/List/Spent/Print/Receipt'),
    },
    {
      path: "/billing/print/:id",
      name: "billing-print",
      component: () => import('./templates/Financial/Releases/List/Spent/Print/Billing'),
    },
    {
      path: "/print-recipe/:doctor_id/:group_prescription_medicine_id/:prescription_medicine_id",
      name: "print-recipe",
      component: () => import('./templates/Resident/Recipe/Print'),
    },
    {
      path: "/print-launch-releases/:type/:cash_competence/:month/:dayMonthYear/:account_ids/:types_of_entries_ids/:users_ids/:provider_ids/:finance_client_ids/:finance_configuration_document_types_ids/:finance_configuration_payment_methods_ids/:finance_configuration_category_ids/:finance_configuration_profit_cost_center_ids/:finance_configuration_tag_ids/:cost_types_ids/:cost_appropriations_ids/:filter_by_period/:start_date/:end_date",
      name: "print-launch-releases",
      component: () => import('./templates/Financial/Releases/Print/List'),
    },
    {
      path: "/print-releases-by-category/:cash_competence/:month/:dayMonthYear/:account_ids/:types_of_entries_ids/:users_ids/:provider_ids/:finance_client_ids/:finance_configuration_document_types_ids/:finance_configuration_payment_methods_ids/:finance_configuration_category_ids/:finance_configuration_profit_cost_center_ids/:finance_configuration_tag_ids/:cost_types_ids/:cost_appropriations_ids/:filter_by_period/:start_date/:end_date",
      name: "print-releases-by-category",
      component: () => import('./templates/Financial/Reports/Print/ReleasesByCategory'),
    },
    {
      path: "/print-releases-by-profit-cost-center/:cash_competence/:month/:dayMonthYear/:account_ids/:types_of_entries_ids/:users_ids/:provider_ids/:finance_client_ids/:finance_configuration_document_types_ids/:finance_configuration_payment_methods_ids/:finance_configuration_category_ids/:finance_configuration_profit_cost_center_ids/:finance_configuration_tag_ids/:cost_types_ids/:cost_appropriations_ids/:filter_by_period/:start_date/:end_date",
      name: "print-releases-by-profit-cost-center",
      component: () => import('./templates/Financial/Reports/Print/ReleasesByProfitCostCenter'),
    },
    {
      path: "/family/residents",
      name: "family_residents",
      component: () => import('./templates/Family/Residents'),
    },
    {
      path: "/family/resident/:id",
      name: "family_resident",
      component: () => import('./templates/Family/Resident'),
    },
    {
      path: "/financial",
      name: "financial",
      component: Financial,
    },
    {
      path: "/family",
      name: "family",
      component: () => import('./views/family.vue'),
    },
    {
      path: "/family/:id",
      name: "family-resident",
      component: () => import('./templates/family-resident/resident.vue'),
    },
    {
      path: "/family/resident/release/print/:id",
      name: "family-resident-release",
      component: () => import('./templates/family-resident/resident/releases/releases-executed/print'),
    },
    {
      path: "/resident/order/print/:id",
      name: "resident-order-print",
      component: () => import('./templates/Resident/order/order/print.vue'),
    },
    {
      path: "/resident/release/hosting/print/:id",
      name: "resident-release-hosting",
      component: () => import('./templates/Resident/HostingFinance/print.vue'),
    },
    {
      path: "/resident/account/print/:resident_id/:type/:origin/:movement/:id",
      name: "resident-account-print",
      component: () => import('./templates/Resident/menu-account/print.vue'),
    },
    {
      path: "/resident/account/prints/:resident_id/:types/:origin/:movement/:ids",
      name: "resident-account-prints",
      component: () => import('./templates/Resident/menu-account/prints.vue'),
    },
    // {
    //   path: "/certificates",
    //   name: "certificates",
    //   component: () => import('./views/certificates'),
    // },
    {
      path: "/help",
      name: "help",
      component: Help,
    },
    {
      path: "/verify-pdf",
      name: "verify-pdf",
      component: VerifyPDF,
    },
    {
      path: "/lists",
      name: "lists",
      component: Lists,
    },
    {
      path: "/list/:id",
      name: "list",
      component: List,
    },
    {
      path: "/list-table/:id/:type",
      name: "list-table",
      component: ListTable,
    },
    {
      path: "/verify/recipe/:rest_home_id/:group_prescription_medicine_id/:prescription_medicine_ids/:doctor_id/:qrcode",
      name: "verify-recipe",
      component: () => import('./views/verify-recipe'),
    },
    {
      path: "/medicine-duplicate",
      name: "medicine-duplicate",
      component: () => import('./views/medicine-duplicate'),
    },
    {
      path: "/residents-vital-signs",
      name: "residents-vital-signs",
      component: () => import('./views/residents-vital-signs'),
    },
    {
      path: "/residents-vital-signs-list",
      name: "residents-vital-signs-list",
      component: () => import('./views/residents-vital-signs-list'),
    },
    {
      path: "/digital-recipe",
      name: "digital-recipe",
      component: () => import('./views/DigitalRecipe'),
    },
    {
      path: "/contract/:resident_id",
      name: "contract",
      component: () => import('./views/Contract'),
    },
    {
      path: "/contract-update/:resident_id/:contract_id",
      name: "contract-update",
      component: () => import('./templates/Contract/ContractUpdate'),
    },
    {
      path: "/contract-print/:contract_id",
      name: "contract-print",
      component: () => import('./templates/Contract/ContractPrintView'),
    },
    {
      path: "/schedule",
      name: "schedule",
      component: () => import('./views/Schedule'),
    },
    {
      path: "/schedule-type",
      name: "schedule-type",
      component: () => import('./views/ScheduleType'),
    },
    {
      path: "/folder",
      name: "folder",
      component: () => import('./views/Folder'),
    },
    {
      path: "/buy",
      name: "buy",
      component: () => import('./views/Buy'),
    },
    {
      path: "/buy/:id",
      name: "buy_details",
      component: BuyDetails,
    },
    {
      path: "/buy-print/:buy_id",
      name: "buy-print",
      component: () => import('./templates/Buy/BuyPrintView'),
    },
    {
      path: "/bry",
      name: "bry",
      component: () => import('./views/BRy'),
    },
    {
      path: "/bry/cloud",
      name: "bry-cloud",
      component: () => import('./views/BRyCloud'),
    },
    {
      path: "/bry/ok",
      name: "bry-ok",
      component: () => import('./views/BRyOk'),
    },
    {
      path: "/folder/docs/:id",
      name: "docs_folder",
      component: DocsFolder,
    },
    {
      path: "/digital-recipe",
      name: "digital_recipe",
      component: () => import('./views/DigitalRecipe'),
    },
    {
      path: "/modules",
      name: "modules",
      component: () => import('./views/Modules'),
    },
    {
      path: "/technical-responsible-my-validations",
      name: "technical-responsible-my-validations",
      component: () => import('./views/TechnicalResponsibleMyValidations'),
    },
    /** fallback */
    { path: "*", component: Dashboard },
  ],
});

export default router;
